<template>
  <div v-if="!loading" class="rounded bg-white overflow-hidden shadow">
    <div class="flex divide-x">
      <div v-if="orderItemParentOrderItem" class="w-64">
        <OrderLinesNav
          :order-item-parent-order-item="orderItemParentOrderItem"
          :current="current"
          @order-line:changed="current = $event"
        />
      </div>
      <div class="flex-1 w-0">
        <OrderItemDetails
          v-if="currentOrderItem"
          :order-item="currentOrderItem"
          :can-copy="canCopy"
          @requirements:copy="copyRequirements"
          @links:copy="copyLinks"
          @notes:copy="copyNotes"
          @media:copy="copyMedia"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderItemDetails from './orderItemParentOrderItem/OrderItemDetails.vue';
import OrderLinesNav from './orderItemParentOrderItem/OrderLinesNav.vue';

export default {
  name: 'OrderItemParentOrderItem',

  components: {
    OrderItemDetails,
    OrderLinesNav,
  },

  props: {
    orderItem: {
      type: Object,
      required: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
    notes: {
      type: Array,
      default: () => [],
    },
    canCopy: Boolean,
  },

  data() {
    return {
      loading: false,
      current: null,
    };
  },

  computed: {
    orderItemWip() {
      return this.$store.state.ui.orderItems.wip;
    },
    orderItemParentOrderItem() {
      return this.$store.state.entities.orderItems.byId[this.orderItem.parentOrderItemUuid] || null;
    },
    currentOrderItem() {
      return this.$store.state.entities.orderItems.byId[this.current] || null;
    },
  },

  created() {
    this.current = this.orderItem.parentOrderItemUuid;
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;
      try {
        await this.$store.dispatch({
          type: 'ui/orderItems/read',
          orderItemUuid: this.orderItem.parentOrderItemUuid,
          params: {
            include: 'order.orderItems.notes,order.orderItems.media,order.orderItems.links',
          },
        });
      } catch (error) {
        /** something went wrong */
      } finally {
        this.loading = false;
      }
    },
    copyRequirements(requirements) {
      this.$emit('update:requirements', requirements);
    },
    copyLinks(links) {
      this.$emit('update:links', [...this.links, ...links]);
    },
    copyNotes(notes) {
      this.$emit('update:notes', [...this.notes, ...notes]);
    },
    copyMedia(mediaAsLinks) {
      this.$emit('update:links', [...this.links, ...mediaAsLinks]);
    },
  },
};
</script>
